import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toggleNotification } from './Actions';
const getTimeFromTimestamp = (timestamp) => {
    const match = /(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})T(?<hour>\d{2}):(?<minut>\d{2})/g.exec(timestamp);
    return `${match.groups.day}-${match.groups.month}-${match.groups.year} ${match.groups.hour}:${match.groups.minut}`;
};
const ComponentListItem = ({ item, openNotification }) => {
    const itemClass = item.is_read ? '' : 'unread';
    const time = getTimeFromTimestamp(item.timestamp);
    return (_jsx("li", Object.assign({ className: itemClass }, { children: _jsxs("button", Object.assign({ onClick: () => openNotification(item) }, { children: [_jsx("p", Object.assign({ className: "date" }, { children: time })), _jsx("div", { dangerouslySetInnerHTML: { __html: item.title } })] })) })));
};
ComponentListItem.propTypes = {
    item: PropTypes.shape({
        is_read: PropTypes.bool,
        timestamp: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    }),
    openNotification: PropTypes.func.isRequired
};
const mapDispatchToProps = (dispatch) => ({ openNotification: (item) => dispatch(toggleNotification(item)) });
export default connect(null, mapDispatchToProps)(ComponentListItem);
